var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3px"},[_c('span',{staticClass:"font-weight-bold text-dark"},[_vm._v(_vm._s(_vm.$t(_vm.leftText))+": ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }